import React from "react";

const StatCard = ({ value, title, description }) => (
  <div className="relative h-full min-h-[280px]">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute bottom-[14px] left-0 right-[14px] top-0 z-0 rounded-[24px] border-2 border-[#565ACF]"
    />

    <article className="relative z-[1] ml-3.5 mt-3.5 flex h-[calc(100%-14px)] min-h-[252px] flex-col rounded-[24px] bg-white px-6 py-8 shadow-[0_12px_32px_rgba(35,45,110,0.1)] md:px-7 md:py-9">
      <p className="text-[42px] font-bold leading-none text-[#ED823B] md:text-[46px]">{value}</p>
      <h3 className="mt-4 text-[18px] font-bold text-[#232D6E] md:text-[19px]">{title}</h3>
      <p className="mt-3 flex-1 text-[13px] leading-[1.75] text-[#6B7280] md:text-[14px]">
        {description}
      </p>
    </article>
  </div>
);

const ServiceStats = ({ experiences }) => {
  const items = Array.isArray(experiences) ? experiences : [];

  if (items.length === 0) return null;

  return (
    <section className="bg-[#F2F2FF] py-16 md:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-stretch gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {items.map((stat) => (
            <StatCard key={stat.id || stat.title} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceStats;
